export default "__VITE_ASSET__201d2a91__"